import { memo } from 'react';
import { SliderMatchesHot } from './slider';

function MatchesHot(props: any) {
    const { items = [] } = props;
    return <SliderMatchesHot items={items} />;
}

export default memo(MatchesHot);
